import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'found';
import { Button, Grid, Loader } from 'semantic-ui-react';
import EventCard from './EventCard';
import moment from 'moment-timezone';
import Waypoint from 'react-waypoint';

const EventListComponent = class EventList extends React.Component {
  static propTypes = {
    viewer: PropTypes.object,
    location: PropTypes.object,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    sidebarOpen: PropTypes.bool.isRequired,
    toggleSidebar: PropTypes.func.isRequired,
    showFilters: PropTypes.bool.isRequired,
    toggleFilters: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      listSize: 10,
      loading: false
    };
    this.showHidden = this.showHidden.bind(this);
    this.groupByMonth = this.groupByMonth.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  showHidden(e) {
    const { query } = this.props.location;
    query.hidden = 'true';
    this.props.router.push({ pathname: '/', query });
    e.preventDefault();
  }

  loadMore() {
    if (this.props.relay.hasMore() && !this.state.loading) {
      this.props.relay.loadMore(5, () => {
        this.setState({ loading: false, listSize: this.state.listSize + 5 });
      });
      this.setState({ loading: true });
    }
  }

  groupByMonth(events) {
    const timeZone = this.props.viewer.s_time_zone;
    if (events.length > 0) {
      let currentMonth = moment
        .tz(events[0].node.start_at, timeZone)
        .startOf('month');
      const groupedEvents = [[]];
      const sortBy = this.props.location.query.sortBy;
      let idx = 0;
      // Do not group events if viewing recent events
      if (sortBy === 'RECENT') {
        // Return array of flattened event nodes
        return [events.map(edge => edge.node)];
      }
      events.map(edge => {
        const event = edge.node;
        if (
          moment.tz(event.start_at, timeZone).isBetween(
            currentMonth,
            currentMonth.clone().add(1, 'months'),
            null,
            '[)'
          )
        ) {
          groupedEvents[idx].push(event);
        } else {
          groupedEvents.push([event]);
          currentMonth = moment.tz(event.start_at, timeZone).startOf('month');
          idx++;
        }
        return edge;
      });
      return groupedEvents;
    }
    return [];
  }

  render() {
    const timeZone = this.props.viewer.s_time_zone;
    const events = this.props.viewer.user_events.edges;
    const { query } = this.props.location;
    const sortBy = query.sortBy || 'UPCOMING';
    const status = query.status || 'ALL';
    const showDateLabel = sortBy !== 'RECENT';

    const sortByText = sortBy.toLowerCase();
    const groupedEvents = this.groupByMonth(events);
    const groupMargin = sortBy === 'RECENT' ? {} : { marginBottom: '3em' };
    const withBookingStatus = (bookingStatus => {
      switch (bookingStatus) {
        case 'BOOKED':
          return ' that are booked';
        case 'INITIAL':
          return ' that are not booked';
        case 'CANCELED':
          return ' that are canceled';
        default:
          return '';
      }
    })(status);

    return (
      <div style={{ width: '100%' }}>
        <Grid.Row>
          <Grid.Column>
            {groupedEvents.map((group, groupIdx) =>
              <div key={groupIdx} style={groupMargin}>
                {sortBy !== 'RECENT' &&
                  <h2>
                    {moment.tz(group[0].start_at, timeZone).format('MMMM YYYY')}
                  </h2>}
                {group.map((event, idx) =>
                  <EventCard
                    showDateLabel={showDateLabel}
                    event={event}
                    timeZone={timeZone}
                    key={idx}
                    index={idx}
                    link
                    location={this.props.location}
                    listSize={this.state.listSize}
                    relay={this.props.relay}
                  />
                )}
              </div>
            )}
            <div style={{ textAlign: 'center', padding: '2em' }}>
              {events.length === 0 &&
                <div>
                  <h2 >{`You have no ${sortByText} events${withBookingStatus}`}</h2>
                  <p style={{ padding: '2em' }}>
                    <Link to='/events/new'>
                      <Button
                        primary
                        icon='plus'
                        labelPosition='left'
                        content='Create New Event'
                      />
                    </Link>
                  </p>
                </div>}
              <Waypoint onEnter={this.loadMore} bottomOffset={-200} />
              {this.props.relay.hasMore() &&
                this.state.loading &&
                <div style={{ marginBottom: '2em' }}>
                  <Loader
                    active
                    inline
                    size='tiny'
                    style={{ marginRight: '1em' }}
                  />{' '}
                  Loading More...
                </div>
              }
              {query.hidden !== 'true' &&
                <p>
                  Excluding hidden events. &nbsp;
                  <a
                    onClick={this.showHidden}
                    style={{ borderBottom: '1px solid' }}
                    href=''
                  >
                    Show all.
                  </a>
                </p>}
            </div>
          </Grid.Column>
        </Grid.Row>
      </div>
    );
  }
};

export default withRouter(EventListComponent);



// WEBPACK FOOTER //
// ./webpack/components/Event/List/EventList.js